<ion-header class="hidden mobile:block">
  <ion-toolbar>
    <ion-title>Approvals</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="mobile:hidden mobile:px-6 px-12 pt-6">
  <div class="max-w-screen-lg">
    <h1 class="text-2xl font-sherika-bold">Approvals</h1>
  </div>
</div>

<ion-content>
  @if (loading()) {
    <app-loader />
  }
  <div
    class="grid grid-cols-[repeat(auto-fill,_minmax(260px,_1fr))] grid-rows-[auto] small-mobile:flex small-mobile:flex-col mobile:p-0 px-8 py-8 max-w-xl min-w-full min-h-full relative content-start"
  >
    @for (entity of model(); track entity.id) {
      <ion-card class="cursor-pointer" (click)="openEntity(entity.id)">
        @if (entity.avatar) {
          <ion-img [src]="entity.avatar" class="aspect-[16/6] object-cover" />
        } @else {
          <ion-img
            [src]="'assets/images/koshery-page-placeholder.webp'"
            class="aspect-[16/6] object-cover"
          />
        }
        <ion-card-header>
          <ion-card-title>{{ entity.name }}</ion-card-title>
          <ion-card-subtitle>&#64;{{ entity.username }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          @if (entity.description) {
            <p>
              {{ entity.description }}
            </p>
          }
          @if (entity.addressText) {
            <strong>{{ entity.addressText }}</strong>
          }
        </ion-card-content>
      </ion-card>
    } @empty {
      <div
        class="text-neutral-600 text-sm absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        Nothing doing at the moment...
      </div>
    }
  </div>
</ion-content>
